import {
  LegendRow,
  LegendDot,
  LegendText,
  LegendLeft,
  LegendValue,
  ChartWrapper,
  ChartContainer,
  LegendContainer,
} from './totalStudentsChartStyled';
import { useSelector } from 'react-redux';
import DefaultDoughnutChart from 'examples/Charts/DoughnutCharts/DefaultDoughnutChart';

const TotalStudentsChart = ({ height }) => {
  const onlineAttendanceStats = useSelector((state) => state.statsData);

  const totalStudentsChartData = {
    labels: ['Online Students', 'Day School'],
    datasets: {
      label: 'Students',
      backgroundColors: ['info', 'warning'],
      data: [
        onlineAttendanceStats?.totalOnlineStudents || 0,
        onlineAttendanceStats?.totalDaySchoolStudents || 0,
      ],
    },
    cutout: 70,
  };

  return (
    <ChartContainer height={height}>
      <ChartWrapper>
        <DefaultDoughnutChart
          chart={totalStudentsChartData}
          height={height || '10rem'}
        />
      </ChartWrapper>

      <LegendContainer>
        <LegendRow>
          <LegendLeft>
            <LegendDot color="#1A73E8" />
            <LegendText>Online Students</LegendText>
          </LegendLeft>
          <LegendValue>
            {onlineAttendanceStats?.totalOnlineStudents || 0}
          </LegendValue>
        </LegendRow>

        <LegendRow>
          <LegendLeft>
            <LegendDot color="#fb8c00" />
            <LegendText>Day School</LegendText>
          </LegendLeft>
          <LegendValue>
            {onlineAttendanceStats?.totalDaySchoolStudents || 0}
          </LegendValue>
        </LegendRow>
      </LegendContainer>
    </ChartContainer>
  );
};

export default TotalStudentsChart;
